import { Badge } from "../../../../components/Badge/Badge";
import type { IUsageInfo } from "../../../../hooks/reactQueryHooks/useUsage";
import {
  formatCurrency,
  shortNumber,
} from "../../../../utils/NumbersFormatting";

interface BadgesProps {
  usageInfo: IUsageInfo;
}

const Badges: React.FC<BadgesProps> = ({ usageInfo }) => {
  return (
    <div className="d-grid grid-stats-section">
      <div className="row gy-5 g-xl-5 row-plex widget-container">
        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant="info"
            content={{
              value: shortNumber(
                usageInfo.totalActiveInputTokensUsed +
                  usageInfo.totalActiveOutputTokensUsed +
                  usageInfo.totalCachedInputTokensUsed +
                  usageInfo.totalCachedOutputTokensUsed,
              ),
              title: "Total tokens",
              tooltipText:
                "Total amount of tokens consumed for the current billing period. The tokens that are generated from cache are free of charge.",
              rightItems: [
                {
                  text: shortNumber(
                    usageInfo.totalActiveInputTokensUsed +
                      usageInfo.totalActiveOutputTokensUsed,
                  ),
                  subtitle: "paid tokens",
                },
                {
                  text: shortNumber(
                    usageInfo.totalCachedInputTokensUsed +
                      usageInfo.totalCachedOutputTokensUsed,
                  ),
                  subtitle: "free tokens",
                },
              ],
            }}
          />
        </div>

        {/* <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant="primary"
            content={{
              value: `${formatCurrency(usageInfo.cogCachePrice)}`,
              title: 'Amount due',
              tooltipText:
                'The total amount due for all the models for the current billing period after deducting the free credits.',
              rightItems: [
                usageInfo.initialDeposit || usageInfo.totalFreeCredits
                  ? {
                      text: `${formatCurrency(usageInfo.initialDeposit)} / ${formatCurrency(
                        usageInfo.totalFreeCredits
                      )}`,
                      subtitle: 'free credits',
                    }
                  : {},
              ],
            }}
          />
        </div> */}

        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-xl-0">
          <Badge
            variant="success"
            content={{
              value: formatCurrency(usageInfo.costSavings),
              title: "Cost savings",
              tooltipText:
                "Amount of cost savings for the current billing period based on token discounts and caching",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export { Badges };
